import { api } from '../index';

const STUDIOS_BASE_URL = 'api/studios';

async function getQuiz(studioURL, id): Promise<SimpleQuizResponse> {
  const result = await api.get(
    `${STUDIOS_BASE_URL}/${studioURL}/quizzes/${id}`
  );
  return result.data;
}

async function viewQuiz(studioURL, id): Promise<void> {
  const result = await api.post(
    `${STUDIOS_BASE_URL}/${studioURL}/quizzes/${id}/view`
  );
  return result.data;
}

async function getSolvedQuizzes(studioURL): Promise<StudentSolvedQuizResponse> {
  const result = await api.get(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes`
  );
  return result.data;
}

async function getSolvedQuiz(
  studioURL,
  id
): Promise<StudentSolvedQuizResponse> {
  const result = await api.get(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes/${id}`
  );
  return result.data;
}

async function startQuiz(
  studioURL,
  quiz_id
): Promise<StudentSolvedQuizResponse> {
  const result = await api.post(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes/start`,
    { quiz_id }
  );
  return result.data;
}

async function retakeQuiz(studioURL, quiz_id): Promise<void> {
  const result = await api.post(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes/retake`,
    { quiz_id }
  );
  return result.data;
}

async function finishQuiz(studioURL, id): Promise<void> {
  const result = await api.post(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes/${id}/finish`
  );
  return result.data;
}

async function answerQuizQuestion(
  studioURL,
  solvedQuizId,
  data: StudentQuizAnswerRrequest
): Promise<void> {
  const result = await api.post(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes/${solvedQuizId}/answer`,
    data
  );
  return result.data;
}

async function addSolvedQuizAnswerFile(
  studioURL,
  solvedQuizId,
  solvedQuizAnswerId,
  file_id
): Promise<void> {
  const result = await api.post(
    `${STUDIOS_BASE_URL}/${studioURL}/solved-quizzes/${solvedQuizId}/answers/${solvedQuizAnswerId}/upload`,
    { file_id }
  );
  return result.data;
}

async function quizInfo(studioURL, quizId): Promise<SimpleQuizResponse> {
  const result = await api.get(
    `${STUDIOS_BASE_URL}/${studioURL}/quizzes/info/${quizId}`
  );
  return result.data;
}

export default {
  getQuiz,
  viewQuiz,
  getSolvedQuizzes,
  getSolvedQuiz,
  startQuiz,
  retakeQuiz,
  finishQuiz,
  answerQuizQuestion,
  addSolvedQuizAnswerFile,
  quizInfo,
};
